import {mainServer} from '../../../../variables/config';

export const request_bank_account = async (id) => {
    const logData = JSON.parse(localStorage.getItem('data'));
    mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
    let response = await mainServer.instance.get("/bankaccount/list/"+id);
    return response.data.data.business_bank;
}
